import { useEffect, useState } from "react";
import { AlertCircle, BookOpen, Pencil } from "lucide-react";

import Field from "./field";
import { callApi, getUserDetails, setToken, setUserDetails } from "./utils";

export default function LoginScreen({ onLogin }) {
  const [error, setError] = useState("");
  const [state, setState] = useState(0);

  const clearError = () => setError("");

  const handleError = (err) => {
    if (typeof err === "string") {
      setError(err);
    } else {
      console.error(err);
    }
  };

  useEffect(() => {
    const userDetails = getUserDetails();
    if (userDetails) {
      onLogin(userDetails);
    }
  }, []);

  const handleLoginResp = (response) => {
    const respErr = response.error;
    if (respErr) {
      const message = response.message;
      if (message) {
        setError(message);
      } else {
        switch (response.status) {
          case 400:
            setError("Пароли не совпадают");
            break;
          case 401:
            setError("Неверный пароль");
            break;
          default:
            handleError(respErr);
        }
      }
    } else {
      const respObj = response.response;
      if (respObj) {
        const { token, ...userDetails } = respObj;
        setToken(token);
        setUserDetails(userDetails);
        onLogin(userDetails);
      } else {
        setError("Некорректный ответ с сервера");
      }
    }
  };

  const handleFormSubmit = (event) => {
    event.preventDefault();

    clearError();

    const data = new FormData(event.target);
    const obj = {};
    for (const pair of data.entries()) {
      obj[pair[0]] = pair[1];
    }
    const body = JSON.stringify(obj);

    switch (state) {
      case 1: {
        callApi({ method: "POST", path: "api/auth/register", body }).then(
          handleLoginResp, // 400
        );
        break;
      }
      case 2: {
        callApi({ method: "POST", path: "api/auth/login", body }).then(
          handleLoginResp, // 401
        );
        break;
      }
      default: {
        callApi({ method: "POST", path: "api/auth/check-email", body }).then(
          (response) => {
            const respErr = response.error;
            if (respErr) {
              handleError(respErr);
            } else {
              const respObj = response.response;
              if (respObj) {
                if (respObj.exists) {
                  if (respObj.registered) {
                    setState(2);
                  } else {
                    setState(1);
                  }
                } else {
                  setError("Неизвестный e-mail");
                }
              } else {
                setError("Некорректный ответ с сервера");
              }
            }
          },
        );
      }
    }
  };

  const renderFormElems = () => {
    const passwordElem = () => (
      <Field label="Пароль" required>
        <input
          type="password"
          name="password"
          minLength={6}
          required
          onChange={clearError}
        />
      </Field>
    );
    const getTailElems = (label) => (
      <>
        {error && (
          <div className="error-box">
            <div>
              <AlertCircle size={14} /> {error}
            </div>
          </div>
        )}
        <button className="auth-btn" type="submit">
          <span>{label}</span>
        </button>
      </>
    );

    if (!state) {
      return getTailElems("Вход / Регистрация");
    }

    if (state === 1) {
      return (
        <>
          {passwordElem()}
          <Field label="Подтверждение" required>
            <input
              type="password"
              name="confirmPassword"
              minLength={6}
              required
              onChange={clearError}
            />
          </Field>
          {getTailElems("Зарегистрироваться")}
        </>
      );
    }

    return (
      <>
        {passwordElem()}
        {getTailElems("Войти")}
      </>
    );
  };

  return (
    <div className="login-wrap">
      <div className="login-card">
        <div className="login-mark">
          <BookOpen size={22} />
        </div>
        <h1>Практика</h1>
        <p className="muted">Платформа сопровождения практических занятий</p>
        <form className="login-form" onSubmit={handleFormSubmit}>
          <Field label="Электронная почта" required>
            <div className="email-container">
              <input
                type="email"
                name="email"
                placeholder="example@edu.ru"
                required
                readOnly={!!state}
                onChange={clearError}
              />
              <button
                className="edit-email"
                disabled={!state}
                title="Изменить e-mail"
                onClick={() => setState(0)}
              >
                {<Pencil size={20} />}
              </button>
            </div>
          </Field>
          {renderFormElems()}
        </form>
        <p className="muted tiny">
          Аутентификация выполняется по e-mail из конфигурационного списка
          студентов/преподавателей.
        </p>
      </div>
    </div>
  );
}
